import React from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import { FormattedMessage } from 'i18n';
import TravelSummary from 'routes/checkoutPage/components/travelSummary/TravelSummary';
import MoreIndicator from 'components/buttons/moreIndicator/MoreIndicatorComponent';
import PackagePrice from 'routes/checkoutPage/components/travelSummary/components/packagePrice/PackagePrice';
import SummaryButton from 'routes/checkoutPage/components/travelSummary/components/summaryButton/SummaryButton';
import flexbox from 'styles/utils/flexbox';
import { mediaQueries } from 'styles/utils/mediaQueries';

function TravelSummaryBarComponent({ open, config, onClickOpenSummary, travelSummaryBarBottom, travelSummaryBarRef }) {
  return (
    <Root travelSummaryBarBottom={travelSummaryBarBottom} ref={travelSummaryBarRef}>
      <Title onClick={onClickOpenSummary}>
        <MoreIndicatorWrap>
          <MoreIndicator small />
        </MoreIndicatorWrap>
        <FormattedMessage
          id={'travelSummary.label'}
          description={'Travel Summary'}
          defaultMessage={'Travel Summary'}
          tagName={'h1'}
        />
        &nbsp;&nbsp;-&nbsp;&nbsp;
        <PackagePrice onTravelSummaryBar />
      </Title>
      <SummaryButton simple />
      <Modal
        isOpen={open}
        onRequestClose={onClickOpenSummary}
        closeTimeoutMS={300}
        overlayClassName='custom-modal'
        className='custom-modal-content'
      >
        <TravelSummary config={config} onClickClose={onClickOpenSummary} />
      </Modal>
    </Root>
  );
}

export default TravelSummaryBarComponent;

const Root = styled.div`
  position: ${({ travelSummaryBarBottom }) => (travelSummaryBarBottom ? 'fixed' : 'relative')};
  bottom: ${({ travelSummaryBarBottom }) => (travelSummaryBarBottom ? '0' : 'unset')};
  ${flexbox({
    justifyContent: 'space-between',
    alignItems: 'center',
  })}
  width: 100%;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.primary.light};
  border-bottom: 1px solid ${({ theme }) => theme.colors.primary.default};
  font-size: 2em;

  ${mediaQueries.fromAndAbove.desktop`
    display: none;
  `}
`;

const Title = styled.button`
  ${flexbox({
    alignItems: 'center',
  })}
  padding: 0;
  background: none;
  border: none;
  font-size: inherit;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.default};

  h1 {
    font-family: ${({ theme }) => theme.fonts.displaySubtle};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.default};
  }

  span {
    font-size: 111%;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.text.price};
  }
`;

const MoreIndicatorWrap = styled.div`
  margin-right: 8px;
  margin-bottom: 2px;
`;
